import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import { APIError } from "../../components/APIError";
import { useNoteDetails } from "./hooks/useNoteDetails";
import {
  CloseButton,
  CustomDialog,
  Field,
} from "../../components/CustomDialog";
import { NoteIcon } from "../../icons";
import {
  Box,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { useFallbackUrl, useNavigator } from "../../components/AppHistory";
import { formatDate } from "../../utils/formatDate";
import { Entry } from "../../api/services";
import { Comment } from "./components/Comment";
import { DialogLoader } from "../../components/Loader";
import { ModalComponent } from "../../pages/routes";

export const NoteDetails: ModalComponent = ({ fallbackUrl }) => {
  useFallbackUrl(fallbackUrl);
  const { accountNumber, noteId } = useParams();
  const { closeOverlay } = useNavigator();
  const { data: note, error, isLoading } = useNoteDetails(
    accountNumber,
    noteId,
  );

  return (
    <CustomDialog onClose={closeOverlay}>
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="no-wrap"
        >
          <Box>
            <Box display="flex" alignItems="center">
              <Box mr={0.5} lineHeight={1}>
                <NoteIcon
                  height={24}
                  width={24}
                  style={{ fill: "currentColor" }}
                />
              </Box>
              <Typography variant="h6">Note</Typography>
            </Box>
            <Box>
              <Typography variant="body1">{note?.subject}</Typography>
            </Box>
          </Box>
          <Box mr={-1.5}>
            <CloseButton data-testid="NoteDetails__Button--close" />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {error ? (
          <APIError
            title="We can't load details for this note at the moment."
            mb={45.5}
          />
        ) : isLoading ? (
          <DialogLoader mb={37} />
        ) : (
          note && (
            <>
              <Box mb={2}>
                <Grid container justify="space-between">
                  <Field
                    data-testid="Field__Created--value"
                    label="Created"
                    value={formatDate(note.createdDttm)}
                  />
                  <Field
                    data-testid="Field__CreatedBy--value"
                    label="Created by"
                    value={note.user}
                  />
                  <Field
                    data-testid="Field__Type--value"
                    label="Type"
                    value={note.type}
                  />
                  <Field
                    data-testid="Field__Summary--value"
                    label="Summary"
                    value={note.summary}
                    fullWidth
                  />
                  <Field
                    data-testid="Field__Content--value"
                    label="Content"
                    value={note.content}
                    fullWidth
                  />
                </Grid>
              </Box>
              <Box>
                <Box mb={1.25}>
                  <Typography variant="overline">
                    ATTACHMENTS AND COMMENTS
                  </Typography>
                </Box>
                <Divider />
                {note.entries.map((entry: Entry) => {
                  return (
                    <Fragment key={`fragment-${entry.id}`}>
                      <Comment entry={entry} />
                      <Divider />
                    </Fragment>
                  );
                })}
                {note.entries.length === 0 && (
                  <Box data-testid="NoteDetails__Comments--empty" mt={1} mb={1}>
                    No attachments or comments for this note.
                  </Box>
                )}
              </Box>
            </>
          )
        )}
      </DialogContent>
    </CustomDialog>
  );
};
